import React, { useState } from "react";
import "./searchInputStyles.css";
import { Actions } from "../../Action/index";
import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { fetchAutosuggestionsData } from "../../API/api";
import { useLocation, useNavigate } from "react-router-dom";
import { removeLineBreak, replacepercentageSymbol } from "../../utils";
import parse from "html-react-parser";
import { CURRENT_ROLE, currentGroupName } from "../../API/url";
import { Home_PAGE_URL } from "../../Router/routerUrl";
import { Checkbox, Select, Tag } from 'antd';


export default function SearchInput() {
  const [suggestion, setSuggestion] = useState([]);
  const currentRoute = useLocation();
  const navigate = useNavigate();
  const [inputWidth, setInputWidth] = useState(0);
  const [isFocus, setIsFocus] = useState(false);
  const searchState = useSelector((state) => state.search);
  const userState = useSelector((state) => state.user);
  const knowledgeEntryState = useSelector((state) => state.knowledgeEntryReducer)

  const dispatch = useDispatch();
  const {
    searchInputValue,
    getAutoSuggestionData,
    updateQuestionUuidForSearch,
    searchDataLoading,
    isBackClickedOnRecommend,
    emptyStateAfterClick,
    advanceFilterModalToggle,
    isShowResultsCPR
  } = bindActionCreators(Actions, dispatch);

  const sendToSearchPage = (e, id = null, val = "") => {
    isBackClickedOnRecommend(false)
    e.preventDefault();
    updateQuestionUuidForSearch(id);
    setSuggestion([]);
    // if(process.env.REACT_APP_MY_LEGACY_SEARCH == 'false'){
      isShowResultsCPR(false)
    // }
    if (val) {
      navigate(
        `${Home_PAGE_URL}search/${encodeURIComponent(replacepercentageSymbol(val))}/true`
      );
    } else {
      navigate(
        `${Home_PAGE_URL}search/${encodeURIComponent(
          replacepercentageSymbol(searchState.inputValue)
        )}/false`
      );
    }
  };

  let keyTriggerCount = 0;
  let keyUpTrigger = false;
  let keyDownTrigger = false;

  const handleKeypress = (e) => {
    if (e.keyCode === 13) {
      if(!keyUpTrigger && !keyDownTrigger){
      }else{
        if (keyUpTrigger === true) {
          keyTriggerCount = keyTriggerCount + 2;
          keyDownTrigger = false;
          keyUpTrigger = false;
        }
        
        let id = suggestion[keyTriggerCount - 1].origQuestionUuid;
        let val = suggestion[keyTriggerCount - 1].question;
        searchInputValue(val);
        isBackClickedOnRecommend(false)
        // if(process.env.REACT_APP_MY_LEGACY_SEARCH == 'false'){
          isShowResultsCPR(false)
        // }
        navigate(
          `${Home_PAGE_URL}search/${encodeURIComponent(replacepercentageSymbol(val))}/true`
        );
        sendToSearchPage(e, id, val);
      }
    }
    if (e.keyCode === 40) {
      if (suggestion.length > 0) {
        if (keyUpTrigger === true) {
          keyTriggerCount = keyTriggerCount + 2;
          keyDownTrigger = true;
          keyUpTrigger = false;
        }
        suggestion.filter((sugs) => {
          document.getElementById(sugs.origQuestionUuid).style.backgroundColor =
            "#fff";
          document.getElementById(sugs.origQuestionUuid).style.color = "#444";
        });
        if (keyTriggerCount > suggestion.length - 1) {
          keyTriggerCount = 0;
        }
        document.getElementById(
          suggestion[keyTriggerCount].origQuestionUuid
        ).style.backgroundColor = "var(--light_color_shade)";
        document.getElementById(
          suggestion[keyTriggerCount].origQuestionUuid
        ).style.color = "#fff";
        if (keyUpTrigger === false) {
          keyTriggerCount = keyTriggerCount + 1;
          keyDownTrigger = true;
          keyUpTrigger = false;
        }
      }
    }
    if (e.keyCode === 38) {
      if (suggestion.length > 0) {
        if (keyDownTrigger === true) {
          keyTriggerCount = keyTriggerCount - 2;
          keyDownTrigger = false;
          keyUpTrigger = true;
        }
        suggestion.filter((sugs) => {
          document.getElementById(sugs.origQuestionUuid).style.backgroundColor =
            "#fff";
          document.getElementById(sugs.origQuestionUuid).style.color = "#444";
        });
        if (keyTriggerCount === -1) {
          keyTriggerCount = 0;
        }
        document.getElementById(
          suggestion[keyTriggerCount].origQuestionUuid
        ).style.backgroundColor = "var(--light_color_shade)";
        document.getElementById(
          suggestion[keyTriggerCount].origQuestionUuid
        ).style.color = "#fff";

        if (keyDownTrigger === false) {
          keyTriggerCount = keyTriggerCount - 1;
          keyDownTrigger = false;
          keyUpTrigger = true;
        }
      }
    }
  };
  const onChangeInputVal = (e) => {
    let elm = document.getElementById('myInput');
    setInputWidth(elm.clientWidth);
    isBackClickedOnRecommend(false);
    keyTriggerCount = 0;
    keyUpTrigger = false;
    keyDownTrigger = false;
    suggestion.filter((sugs) => {
      document.getElementById(sugs.origQuestionUuid).style.backgroundColor =
        "#fff";
      document.getElementById(sugs.origQuestionUuid).style.color = "#444";
    }); 
    searchInputValue(e.target.value);
    if (e.target.value === "") {
      setSuggestion([]);
    } else {
      fetchAutosuggestionsData(e.target.value, getAutoSuggestionData)
        .then((res) => {
          if (res===undefined) return;
          setSuggestion(res);
        })
        .catch((err) => {});
    }
  };

  const onChangeInputValFromAutoSuggestion = (val, id) => {
    updateQuestionUuidForSearch(id);
    setSuggestion([]);
    // if(process.env.REACT_APP_MY_LEGACY_SEARCH == 'false'){
      isShowResultsCPR(false)
    // }
    if (currentRoute.pathname.includes("/search")) {
      navigate(
        `${Home_PAGE_URL}search/${encodeURIComponent(replacepercentageSymbol(val))}/true`
      );
    } else {
      navigate(
        `${Home_PAGE_URL}search/${encodeURIComponent(replacepercentageSymbol(val))}/true`
      );
    }
  };

  const isBestResultAvailable = () => {
    let result = false;
    searchState.origSearchData.length > 0 &&
      searchState.origSearchData.filter((obj) => {
        if (obj.confidence === true && result === false) {
          result = true;
        }
        return obj;
      });
    return result;
  };
  const onBlurrInputField = () => {
    setIsFocus(false);
    setTimeout(() => {
      setSuggestion([]);
    }, 300);
  };
  const sendToQAPairPage =() => {
    navigate('/expertHome/createqapair');
    emptyStateAfterClick();
  }
  return (
    <div>
      {process.env.REACT_APP_MY_SEARCH_DISABLE=='true' && <div className="mb-2"><Tag color="red">Vizerto Model updates are currently running in the background. Please revisit in 30 minutes</Tag></div>}
      <form>
        <span style={{ display: "flex" }}>
          <input
            id="myInput"
            className="form-control searchInput"
            placeholder={`Ask your Question in Group: ${currentGroupName()}`}
            value={searchState.inputValue}
            maxLength={200}
            onChange={(e) => onChangeInputVal(e)}
            onBlur={() => onBlurrInputField()}
            onFocus={()=>setIsFocus(true)}
            autoComplete="off"
            onKeyDown={handleKeypress}
            style={{boxShadow: isFocus && `2px 2px 50px lightgrey`,borderColor: `#878787`, borderInlineEnd:'none'}}
          />
          <div style={{border:'1px solid rgb(135, 135, 135)', background:'#fff', borderInline:'none', display:'flex',justifyContent:'center',alignItems:'center'}}>
          <img onClick={()=>advanceFilterModalToggle({ bool: true, value: "advanceFilter" })} src={require('../../Images/sort.png')} style={{width:'25px', height:'25px', marginRight:'5px', cursor:'pointer'}}/>
          </div>
          <button
            className="searchButton btn"
            type="submit"
            disabled={searchState.inputValue.length > 3 ? false : true}
            onClick={(e) => sendToSearchPage(e)}
          >
            Get Answers
          </button>
        </span>
      </form>
      {suggestion.length > 0 && (
        <div
          className={`searchsuggestiondiv2`}
          style={{
            position: "absolute",
            background: "#ffffff",
            zIndex: "1000",
            width:`${inputWidth+33}px`
          }}
        >
          {suggestion.map((obj) => {
            return (
              <div
                key={obj.origQuestionUuid}
                id={obj.origQuestionUuid}
                className="searchsuggestiondiv"
                onClick={(e) =>
                  onChangeInputValFromAutoSuggestion(
                    obj.question,
                    obj.origQuestionUuid
                  )
                }
              >
                <span id={`${obj.origQuestionUuid}_0`}>{obj.question}</span>
              </div>
            );
          })}
        </div>
      )}
      <div className="minibranding">
        {CURRENT_ROLE === "Seeker" && <label>
          {currentRoute.pathname.includes(`${Home_PAGE_URL}search/`) &&
            !isBestResultAvailable() &&
            !searchState.isLoading && (
              <>
                <span style={{ color: "#00A5FB", fontWeight: "500" }}>
                  <span style={{ color: "#EF7929" }}>
                    <i
                      style={{ fontSize: "14px" }}
                      className="fa fa-lightbulb-o"
                    ></i>
                    &nbsp;Hint:{" "}
                  </span>
                  Thats a nice try!I'm still learning to answer this. Try asking
                  with more context.
                </span>
                <br />
              </>
            )}
          {userState.brandingText === undefined
            ? null
            : parse(removeLineBreak(userState.brandingText))}
        </label>}
        {CURRENT_ROLE === "Expert" && <label>
              <>
                <span style={{ color: "#00A5FB", fontWeight: "400", fontSize:'15px', cursor:'pointer' }} onClick={()=>sendToQAPairPage()}>
                  <span >
                    <i
                    style={{fontWeight:'bold'}}
                      className="fa fa-plus"
                    ></i>
                    &nbsp;
                  </span>
                  Create a new knowledge base entry
                </span>
                <br />
              </>
        </label>}
        <span style={{ float: "right", marginTop:'-5px' }}>
          {currentRoute.pathname.includes("/seekerHome/") && <span onClick={()=>advanceFilterModalToggle({ bool: true, value: "rfpMultiQ" })} style={{color:'rgb(31, 147, 210)', cursor:'pointer', fontWeight:'bold'}}><span style={{fontWeight:'bold', fontSize:'18px'}}>+ </span>Multi-Questions&nbsp;&nbsp;&nbsp;</span>}
          Characters: {200 - searchState.inputValue.length}/200
        </span>
      </div>
    </div>
  );
}
